class RadioToggle {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.inputs = self.elem.querySelectorAll('[data-radio-toggle-input]');
        self.labels = self.elem.querySelectorAll('[data-radio-toggle-label]');
    }

    init() {
        let self = this;

        self.inputs.forEach((item) => {
            item.addEventListener('click', evt => {
                self.labels.forEach((label) => {
                    label.classList.remove('is-selected');

                    if (item.id == label.getAttribute('for')) {
                        label.classList.add('is-selected');
                    }
                });
            });
        });
    }
}

export default RadioToggle;
